import { render, staticRenderFns } from "./enterInfoJyj.vue?vue&type=template&id=4d5641d1&scoped=true"
import script from "./enterInfoJyj.vue?vue&type=script&lang=js"
export * from "./enterInfoJyj.vue?vue&type=script&lang=js"
import style0 from "./enterInfoJyj.vue?vue&type=style&index=0&id=4d5641d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5641d1",
  null
  
)

export default component.exports